import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Overview from './overview';
import Demographics from './Demographics';
import DemographicsSQ from './DemographicsSQ';
import Recruitment from './RecruitmentTransport';
import RecruitmentMap from './RecruitmentMap';
import Control from './ControlOps';
import CaseManagement from './CaseManagement';
import CaseManagementSQ from './CaseManagementSQ';

const Dashboard = () => {
  const [selectedTab, setSelectedTab] = useState('Overview');

  const renderTab = () => {
    switch (selectedTab) {
        case 'Overview': return <Overview />;
        case 'Demographics': return <Demographics />;
        case 'DemographicsSQ': return <DemographicsSQ />;
        case 'Recruitment': return <Recruitment />;
        case 'RecruitmentMap': return <RecruitmentMap />;
        case 'Control': return <Control />;
        case 'CaseManagement': return <CaseManagement />;
        case 'CaseManagementSQ': return <CaseManagementSQ />;
        default: return <Overview />;
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <div style={{ flex: 1, padding: '20px' }}>
        {renderTab()}
      </div>
    </div>
  );
};

export default Dashboard;